import { TabsPanel } from "../../../../../features/ui"
import { LinkedProductsPanel } from "../linked-products/linked-products-panel/linkedProductsPanel"
import { ProductYieldPanel } from "../product-yield-panel/productYieldPanel"
import { NegativeStockPanel } from "../../negative-stock/negative-stock-panel/negativeStockPanel"

export const ProductSettingsPanel = () => {
    const tabs = [
        {
            id: 'product-yield',
            title: 'Rentabilidad',
            content: <ProductYieldPanel />
        },
        {
            id: 'linked-products',
            title: 'Productos Asociados',
            content: <LinkedProductsPanel />,

        },
        {
            id: 'negative-stock',
            title: 'Venta Sin Stock',
            content: <NegativeStockPanel />
        }
    ]

    return (
        <TabsPanel
            title="Configuración"
            tabs={tabs}
        />
    )
}
